getExperiment = require 'lib/experiments/simple-test'
PluginButtonsView = require 'views/plugin/plugin-buttons-view'
PluginCardButtonView = require 'views/plugin/plugin-card-button-view'
simpleTest = require 'lib/experiments/simple-test'
sidebarAction = require 'views/templates/card_detail_sidebar_button'
t = require('views/internal/teacup-with-helpers')('card_detail')

CUSTOM_FIELDS_ID = require 'data/custom-fields-id'

nativeCustomFieldsEnabled = (board) ->
  board.isPluginEnabled(CUSTOM_FIELDS_ID) &&
  board.editable()

template = t.renderable ({ showCustomFields, minimizedCardBack }) ->
  t.h3 {
    class: t.classify('card-detail-item-header': minimizedCardBack, 'mod-no-top-margin': minimizedCardBack)
  }, ->
    t.format 'plugins'
  t.div '.u-clearfix.js-button-list.card-detail-section-mini-buttons', ->
    if showCustomFields
      sidebarAction('js-edit-fields', 'custom-field', 'custom-fields', minimizedCardBack)

module.exports = class PluginCardButtonsView extends PluginButtonsView
  tagName: 'div'
  className: if getExperiment('minimizedCardBack').get('enabled') then 'window-module u-clearfix card-detail-section-mini hide' else 'window-module u-clearfix hide'
  buttonsSelector: '.js-button-list'
  buttonView: PluginCardButtonView

  hideContainer: (pluginButtons) ->
    pluginButtons.length == 0 && !nativeCustomFieldsEnabled(@model.getBoard())

  renderContainer: ->
    showCustomFields = nativeCustomFieldsEnabled(@model.getBoard())
    minimizedCardBack = getExperiment('minimizedCardBack').get('enabled')
    @$el.html(template({ showCustomFields, minimizedCardBack }))
    @$('.js-button-list')

  runnerOptions: ->
    command: 'card-buttons'
    board: @model.getBoard()
    card: @model



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-card-buttons-view.coffee